var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_23",
    "data-name": "Group 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 69.113,
    height: 83.518,
    viewBox: "0 0 69.113 83.518",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 69.113,
    height: 83.518,
    fill: "none",
    stroke: "#707070",
    strokeWidth: 7
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M15.683,55.381l4.7-9.9a3.966,3.966,0,0,0-1.44-4.434L6.643,32.11a3.966,3.966,0,0,1,2.331-7.174h15.2a3.965,3.965,0,0,0,3.771-2.74l4.7-14.456a3.965,3.965,0,0,1,7.543,0l4.7,14.456a3.965,3.965,0,0,0,3.771,2.74h15.2a3.965,3.965,0,0,1,2.331,7.174l-12.3,8.934a3.966,3.966,0,0,0-1.44,4.434l4.7,14.456a3.966,3.966,0,0,1-6.1,4.434l-12.3-8.934a3.965,3.965,0,0,0-4.662,0",
    transform: "translate(-1.857 -1.857)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_19",
    "data-name": "Line 19",
    x2: 9.783,
    y2: 8.59,
    transform: "translate(33.179 65.834)",
    fill: "#d9a673",
    stroke: "#707070",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20",
    "data-name": "Line 20",
    x2: 9.783,
    y2: 8.59,
    transform: "translate(33.179 65.834)",
    fill: "none",
    stroke: "#d9a673",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_21",
    "data-name": "Line 21",
    x1: 0.146,
    y2: 14.54,
    transform: "translate(33.033 65.834)",
    fill: "#d9a673",
    stroke: "#707070",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_22",
    "data-name": "Line 22",
    x1: 0.146,
    y2: 14.54,
    transform: "translate(33.033 65.834)",
    fill: "none",
    stroke: "#d9a673",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.d319e3de2c60d37181e1cc0cda8da06b.svg";
export { ForwardRef as ReactComponent };